import React from 'react';
import PageTemplate from '../PageTemplate';

const Organization = () => {
  return (
    <PageTemplate
      title="🏢 조직도"
      description="청소년 스마트폰 프리 운동본부의 조직 구성을 소개합니다"
    >
      <div>
        {/* 모바일 반응형 스타일 */}
        <style>
          {`
            .org-chart {
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 2rem;
            }
            
            .org-level {
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 2rem;
              flex-wrap: wrap;
            }
            
            .org-box {
              background: linear-gradient(135deg, #4a7c59, #3e6b4a);
              color: white;
              padding: 1rem 2rem;
              border-radius: 25px;
              text-align: center;
              font-weight: bold;
              font-size: 1.1rem;
              box-shadow: 0 4px 15px rgba(74, 124, 89, 0.3);
              min-width: 120px;
            }
            
            .org-box-small {
              background: linear-gradient(135deg, #7ba05b, #6a8f4f);
              color: white;
              padding: 0.8rem 1.5rem;
              border-radius: 20px;
              text-align: center;
              font-weight: bold;
              font-size: 1rem;
              box-shadow: 0 3px 12px rgba(123, 160, 91, 0.3);
              min-width: 100px;
            }
            
            .org-departments {
              display: flex;
              justify-content: center;
              gap: 1rem;
              flex-wrap: wrap;
              margin-top: 1rem;
            }
            
            .org-dept {
              background: white;
              border: 2px solid #4a7c59;
              color: #4a7c59;
              padding: 1rem;
              border-radius: 15px;
              text-align: center;
              font-weight: bold;
              font-size: 0.9rem;
              min-width: 80px;
              box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            }
            
            .connecting-line {
              width: 2px;
              height: 30px;
              background: #4a7c59;
              margin: 0 auto;
            }
            
            .horizontal-line {
              height: 2px;
              background: #4a7c59;
              flex: 1;
              margin: 0 1rem;
            }
            
            .mentor-desktop {
              display: block;
            }
            
            .mentor-mobile {
              display: none;
            }

            @media (max-width: 768px) {
              .org-level {
                flex-direction: column;
                gap: 1rem;
              }
              
              .org-departments {
                flex-direction: column;
                align-items: center;
                gap: 0.5rem;
              }
              
              .org-box, .org-box-small {
                min-width: 150px;
                font-size: 1rem;
              }
              
              .horizontal-line {
                display: none;
              }
              
              .mentor-desktop {
                display: none;
              }
              
              .mentor-mobile {
                display: block;
              }
            }
          `}
        </style>

        {/* 조직도 이미지 */}
        <div style={{
          textAlign: 'center',
          marginBottom: '3rem'
        }}>
          <h3 style={{ color: '#4a7c59', marginBottom: '2rem', fontSize: '1.4rem' }}>
            📋 조직도
          </h3>
          <img 
            src="/Organization.png" 
            alt="청소년 스마트폰 프리 운동본부 조직도" 
            style={{
              maxWidth: '100%',
              height: 'auto'
            }}
          />
        </div>

        {/* 스프운동본부 고문단 */}
        <div style={{ marginBottom: '3rem' }}>
          <h3 style={{ color: '#4a7c59', marginBottom: '1.5rem', fontSize: '1.3rem', textAlign: 'center' }}>
            📋 스프운동본부 고문단
          </h3>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
              <tbody>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김상곤</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 사회부총리</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>고명진</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>한국청소년단체협의회 회장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>최기주</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>아주대 총장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>강성영</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>한신대 총장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>원용걸</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>서울시립대 총장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김점석</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 교원대 총장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>장성근</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>변호사</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>홍성욱</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 크로아티아 대사</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김누리</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>중앙대 독어독문학과 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', fontWeight: 'bold', color: '#4a7c59' }}>이훈진</td>
                  <td style={{ padding: '12px 16px' }}>서울대 심리학과 교수</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* 스프운동본부 자문단 */}
        <div style={{ marginBottom: '3rem' }}>
          <h3 style={{ color: '#4a7c59', marginBottom: '1.5rem', fontSize: '1.3rem', textAlign: 'center' }}>
            📋 스프운동본부 자문단
          </h3>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
              <tbody>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>이범</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>교육평론가</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>황현필</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>한국사 강사</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김의태</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>서울대병원 정신과 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김유겸</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>서울대 체육교육학과 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>정수경</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>초등교사노동조합위원장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>홍사훈</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. KBS 기자</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', fontWeight: 'bold', color: '#4a7c59' }}>정준희</td>
                  <td style={{ padding: '12px 16px' }}>언론인</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* 스프운동본부 멘토단 */}
        <div style={{ marginBottom: '3rem' }}>
          <h3 style={{ color: '#4a7c59', marginBottom: '1.5rem', fontSize: '1.3rem', textAlign: 'center' }}>
            📋 스프운동본부 멘토단
          </h3>
          
          {/* 데스크톱 테이블 */}
          <div className="mentor-desktop" style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
              <tbody>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>강준호</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>서울대 사범대학장</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김영남</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 운천고 교장</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>이재림</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 교원대 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>강철</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>한경대 교수</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김용련</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>한국외대 교육학과 교수</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>이용구</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>공교육이 꽃피는 세상 대표</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>고승안</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 오산고 교장</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김학윤</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 교사</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>이종우</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 수청초 교장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>고일석</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 운천초 교장</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김회웅</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>수원디지털대 교수</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>이홍구</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>경기대 스포츠건강과학전공 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>구교열</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 화성오산교육장</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>맹상호</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 경기교육청 과장</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>임영문</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 대전대 총장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>권영탁</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>오산대 홍보처장</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>문태혁</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>효원초 교장</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>장준호</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>경인교대 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김선오</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 화성오산교육장</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>박성수</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 운산초 교장</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>채수일</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 한신대 총장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김성천</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>한국교원대 교수</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>방현석</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>중앙대 문예창작학과 교수</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>최종환</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>은혜여고 교장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김수애</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 교사</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>성은주</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 과천고 교장</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>홍성택</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전주대 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', fontWeight: 'bold', color: '#4a7c59' }}>김영수</td>
                  <td style={{ padding: '12px 16px' }}>전. 오산중 교장</td>  
                  <td style={{ padding: '12px 16px', fontWeight: 'bold', color: '#4a7c59' }}>윤준영</td>
                  <td style={{ padding: '12px 16px' }}>한세대 교수</td>
                  <td style={{ padding: '12px 16px', fontWeight: 'bold', color: '#4a7c59' }}>황윤규</td>
                  <td style={{ padding: '12px 16px' }}>전 경기교육청 국장</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* 모바일 테이블 */}
          <div className="mentor-mobile" style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
              <tbody>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>강준호</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>서울대 사범대학장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>강철</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>한경대 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>고승안</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 오산고 교장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>고일석</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 운천초 교장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>구교열</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 화성오산교육장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>권영탁</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>오산대 홍보처장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김선오</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 화성오산교육장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김성천</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>한국교원대 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김수애</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 교사</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김영남</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 운천고 교장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김영수</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 오산중 교장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김용련</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>한국외대 교육학과 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김학윤</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 교사</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>김회웅</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>수원디지털대 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>맹상호</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 경기교육청 과장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>문태혁</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>효원초 교장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>박성수</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 운산초 교장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>방현석</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>중앙대 문예창작학과 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>성은주</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 과천고 교장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>윤준영</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>한세대 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>이용구</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>공교육이 꽃피는 세상 대표</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>이재림</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 교원대 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>이종우</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 수청초 교장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>이홍구</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>경기대 스포츠건강과학전공 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>임영문</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 대전대 총장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>장준호</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>경인교대 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>채수일</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전. 한신대 총장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>최종환</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>은혜여고 교장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>홍성택</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>전대 교수</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', fontWeight: 'bold', color: '#4a7c59' }}>황윤규</td>
                  <td style={{ padding: '12px 16px' }}>전 경기교육청 국장</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <p style={{ textAlign: 'right', fontSize: '0.9rem', color: '#666', marginTop: '0.5rem' }}>※ 순서는 가나다 순</p>
        </div>

        {/* 스프운동본부 대표단 */}
        <div style={{ marginBottom: '3rem' }}>
          <h3 style={{ color: '#4a7c59', marginBottom: '1.5rem', fontSize: '1.3rem', textAlign: 'center' }}>
            📋 스프운동본부 대표단
          </h3>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
              <tbody>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>이동현</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>평택대 총장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>최승일</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>교사 / 전. 화성고 교장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>이선근</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>수원특례시 학교운영위원협의회 회장</td>
                </tr>
                <tr>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>이혁규</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>파주중학교 교장</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>배지훈</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>공교육이 꽃피는 세상 경기대표</td>
                </tr>

                <tr>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6', fontWeight: 'bold', color: '#4a7c59' }}>안민석</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid #dee2e6' }}>명지대 석좌교수</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* 스프운동본부 참가단체 */}
        <div style={{ marginBottom: '3rem' }}>
          <h3 style={{ color: '#4a7c59', marginBottom: '1.5rem', fontSize: '1.3rem', textAlign: 'center' }}>
            📋 스프운동본부 참가단체
          </h3>
          <div style={{ 
            background: 'white', 
            padding: '2rem', 
            borderRadius: '8px', 
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            lineHeight: '2'
          }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', justifyContent: 'center' }}>
              {[
                '한국청소년단체협의회',
                '경기교육시민포럼',
                '경기도다문화가정학부모교육네트워크',
                '경기어린이집연합회',
                '경기유치원연합회',
                '군포마을교육공동체협의회',
                '김포게임스마트폰중독예방시민연대',
                '느린학습자부모연대',
                '늘품부모협회',
                '사)청년미래희망재단',
                '새솔동학부모연합협의회',
                '수원교육단체포럼',
                '수원직장어린이집연합회',
                '수원특례시학교운영위원협의회',
                '안산학부모연합회',
                '오산시민교육네트워크',
                '전국교대총동문협의회',
                '파주상상교육포럼',
                '한국곰두리봉사회',
                '한국사립유치원어린이집총연합회',
                '(사)한국유치원총연합회',
                '한국어린이집총연합회',
                '화성시학부모연대교육공감',
                '공교육이꽃피는세상',
                '도박없는학교'
              ].map((organization, index) => (
                <span key={index} style={{ 
                  background: '#f8f9fa', 
                  padding: '0.5rem 1rem', 
                  borderRadius: '20px', 
                  border: '1px solid #dee2e6',
                  fontSize: '0.95rem',
                  color: '#4a7c59',
                  fontWeight: '500'
                }}>
                  {organization}
                </span>
              ))}
            </div>
          </div>
        </div>
        
      </div>
    </PageTemplate>
  );
};

export default Organization; 